import { Tag } from 'src/services/tag/Tag';

export function trackByTagId(index: number, tag: Tag) {
  return tag.id;
}
